<template>
    <span class="display-contents">
        <div class="analyst-data-flex-col">
            <template v-if="itemsCol1.length > 0">
                <municipalities-item v-for="municipality in itemsCol1" :key="municipality.id" :municipality="municipality" />
            </template>
            <p v-else class="-dimmed">. . .</p>
        </div>
        <div class="analyst-data-flex-col">
            <municipalities-item v-for="municipality in itemsCol2" :key="municipality.id" :municipality="municipality" />
        </div>
    </span>
</template>

<script>
import { omit, get, take, takeRight } from 'lodash';
import { transmitter } from '../vuex/Transmitter';
import MunicipalitiesItem from './municipalities-item';

export default {
    name: 'municipalities-list',
    components: {
        MunicipalitiesItem
    },

    props: {
        params: {
            type: Object,
            required: true,
        },
    },

    data()
    {
        return {
            itemsCol1: [],
            itemsCol2: [],
        };
    },

    created()
    {
        const params = omit(this.params, ['call']);
        transmitter.loadContent(this.params.call, params).then((response) =>
        {
            const results = get(response, 'data.data', []);
            if (results.length > 12)
            {
                // Separate in 2 cols:
                const middle = Math.ceil(results.length / 2);
                this.itemsCol1 = take(results, middle);
                this.itemsCol2 = takeRight(results, results.length - middle);
            }
            else
            {
                this.itemsCol1 = results;
                this.itemsCol2 = [];
            }
        });

    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/municipalities-list.vue